import React, { FC, Fragment, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { pathToRegexp } from 'path-to-regexp';
import { Menu } from 'antd';
import { arrayToTree, queryAncestors } from '@app/utils';
import iconMap from '@app/utils/iconMap';
import { ThemesEnum } from '@app/modules/Auth';
import { SiderMenuItem } from '@app/common/Layout/Sider';

const { SubMenu } = Menu;

interface SiderMenuInterface {
  menus: SiderMenuItem[];
  theme?: ThemesEnum;
  isMobile: boolean;
  collapsed: boolean;
  onCollapseChange: Function;
}
export const SiderMenu: FC<SiderMenuInterface> = ({ menus, theme, isMobile, collapsed, onCollapseChange }) => {
  const location = useLocation();
  // @todo from store
  const [openKeys, setKeys] = useState([]);

  const onOpenChange = openKeys => {
    const rootSubmenuKeys = menus.filter(_ => !_.menuParentId).map(_ => _.id);

    const latestOpenKey = openKeys.find(key => openKeys.indexOf(key) === -1);

    let newOpenKeys = openKeys;
    if (rootSubmenuKeys.indexOf(latestOpenKey) !== -1) {
      newOpenKeys = latestOpenKey ? [latestOpenKey] : [];
    }

    setKeys(newOpenKeys);
  };

  const generateMenus = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <SubMenu
            key={item.id}
            title={
              <Fragment>
                {item.icon && iconMap[item.icon]}
                <span>{item.name}</span>
              </Fragment>
            }
          >
            {generateMenus(item.children)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item key={item.id}>
          <Link to={item.route || '#'}>
            {item.icon && iconMap[item.icon]}
            <span>{item.name}</span>
          </Link>
        </Menu.Item>
      );
    });
  };

  // Generating tree-structured data for menu content.
  const menuTree = arrayToTree(menus, 'id', 'menuParentId');

  // Find a menu that matches the pathname.
  const currentMenu = menus.find(_ => _.route && pathToRegexp(_.route).exec(location.pathname));

  // Find the key that should be selected according to the current menu.
  const selectedKeys = currentMenu ? queryAncestors(menus, currentMenu, 'menuParentId').map(_ => _.id) : [];

  const menuProps = collapsed
    ? {}
    : {
        openKeys
      };

  return (
    <Menu
      mode="inline"
      theme={theme}
      onOpenChange={onOpenChange}
      selectedKeys={selectedKeys}
      onClick={
        isMobile
          ? () => {
              onCollapseChange(true);
            }
          : undefined
      }
      {...menuProps}
    >
      {generateMenus(menuTree)}
    </Menu>
  );
};
